import { useQuery } from 'react-query';
import { Field } from '../_types';
import { fetcher, ServerErrorResponse, performanceReportingApiUrl } from 'data_sources/constants';

// Fetch field by ID from API
const getFieldByID = async (
  fieldId: number,
  expandCategory: boolean = false,
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void
): Promise<Field> => {
  try {
    let url = `${performanceReportingApiUrl()}/performance/fields/v1/fields/${fieldId}`;
    if (expandCategory) {
      url += '?expand=fieldCategory,fieldOptions';
    }
    const resp = await fetcher({
      method: 'get',
      url,
      options: { signal },
    });
    return resp as Field;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export const useField = (
  fieldId: number,
  expandCategory: boolean = false,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) => {
  return useQuery({
    queryKey: ['field', fieldId, expandCategory],
    queryFn: ({ signal }) => getFieldByID(fieldId, expandCategory, signal, onError),
    enabled: !!fieldId,
    ...options,
  });
};

export { getFieldByID };
